export default __webpack_public_path__ + "static/media/LINK-QUICK.67d63591.png";